import * as React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Toolbar from "@mui/material/Toolbar";
import Paper from "@mui/material/Paper";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import {
  createApplication,
  fetchAllApplications,
  getAllCities,
  updateApplication,
  updateStage,
  updateStageV2,
} from "../../api";
import { GlobalContext } from "../../Context/GlobalContext";
import { toast } from "react-toastify";
import useApplication from "../../hooks/useApplication";
import {
  Autocomplete,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Select,
  Slide,
  TextField,
} from "@mui/material";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { statusColors } from "../../Constants/colors";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import EditIco from "../../assets/edit.svg";
import { f, formatDate, fStatus } from "../../utility/Formater";
import { useState } from "react";
import { stageList } from "../../utility/StagesV2";
import uploadIco from "../../assets/edit-stage.png";
import { useEffect } from "react";
import moment from "moment";
import DatePickerComponent from "../../Components/DatePicker";
import { DatePicker } from "@material-ui/pickers";
import { environment } from "../../config";
import UpdateDisbursalData from "../../Components/AssignNBFC/UpdateDisbursal";
import { forwardRef } from "react";
import AutocompleteCityNames from "../../Components/AutocompleteCityNames";

const theme = createTheme();
const intialStageData = {
  stage: "",
  status: "",
  sub_status: "",
  master_city: "",
  master_pincode: "",
  remarks: "",
  nbfc_id: "",
};

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function UpdateStageV2() {
  const { updateDetailState, customersList, panData, clearUpdateState } =
    React.useContext(GlobalContext);

  const navigate = useNavigate();
  const { app_id } = useParams();
  const { state } = useLocation();
  const [updateDetails, setUpdateDetails] = updateDetailState;

  // console.log("=====>>> ", updateDetails);

  const [doneUpdate, setDoneUpdate] = React.useState(false);
  const [isLoading, setLoading] = React.useState(false);
  const [application_id, setApplicationId] = React.useState("");
  const [applications, setApplications] = React.useState([]);

  const [open, setOpen] = React.useState(false);
  const [stageData, setStageData] = useState(intialStageData);

  const nbfcData = [
    { name: "NY Leasing", nbfc_id: "NY00002" },
    { name: "Prestloans", nbfc_id: "PY00003" },
  ];

  const handleClickOpen = () => {
    if (
      ["DISBURSAL", "DISBURSEMENT"]?.includes(stageData?.stage) &&
      stageData?.status === "APPROVED" &&
      stageData?.sub_status === "DISBURSED"
    ) {
      setOpenDisbursal(true);
    } else {
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  // Disbursal Modal States

  const [openDisbursal, setOpenDisbursal] = React.useState(false);

  const handleOpenDisbursal = () => {
    setUpdateDetails({
      ...updateDetails,
      disbursal_date: moment().format("DD-MM-YYYY"),
    });
    setOpenDisbursal(true);
  };

  const handleCloseDisbursal = () => {
    setOpenDisbursal(false);
  };

  const validateDisbursalData = async (updateData) => {
    let {
      loan_amount,
      interest,
      interest_rate,
      interest_collected,
      processing_rate,
      processing_fee,
      pf_collected,
      other_charges,
      // installment,
      principal_amount,
      hold_back_amount,
      hold_back_mode,
      subvention_amount,
      subvention_mode,
      disbursal_amount,
      repayment_amount,
      utr,
      tenure_type,
      payment_basis,
      tenure_value,
      disbursal_date,
      mandate_id,
      enach_mandate_id,
      embifi_disbursed_date,
      nbfc_id,
    } = updateData;

    let payload = {
      // Old payload

      subvention_amount: Number(subvention_amount),
      hold_back_amount: Number(hold_back_amount),
      loan_amount,
      interest_rate,
      interest_amount: interest,
      interest_collection_type: interest_collected,
      processing_charge_rate: processing_rate,
      processing_charge: processing_fee || null,
      processing_fee_mode: pf_collected,
      other_charges,
      principal_amount,
      repayment_amount,
      tenure_type,
      tenure_value,
      payment_basis,
      disbursed_amount: disbursal_amount,

      // Payload for Disbursal State

      disbursed_date: disbursal_date || moment().format("DD/MM/YYYY"),
      utr,
      mandate_id,
      enach_mandate_id,

      ...(nbfc_id === "NAM0007"
        ? {
            embifi_disbursed_date:
              embifi_disbursed_date || moment().format("DD/MM/YYYY"),
          }
        : {}),
    };

    // console.log("payload: ", payload);

    let errors = {};
    let valid = true;

    for (let key in payload) {
      if (
        [
          // "disbursed_amount",
          "disbursed_date",
          "utr",
          ...(nbfc_id === "NAM0007" ? ["embifi_disbursed_date"] : []),
        ].includes(key) &&
        [undefined, null, ""].includes(payload[key])
      ) {
        errors = { ...errors, [key]: "Cannot be blank" };
        valid = false;
      }
    }

    // let checkArr = [null, "", undefined];
    // if (
    //   checkArr.includes(payload?.mandate_id) &&
    //   checkArr.includes(payload?.enach_mandate_id)
    // ) {
    //   errors = { ...errors, mandate_id: "Cannot be blank" };
    //   valid = false;
    // }

    if (valid) {
      handleUpdate(payload);
    } else {
      console.log(errors);
      toast.error("Fill required fields and try again");
    }
  };

  const handleUpdate = async (loan_details) => {
    //   // alert("huii");
    handleClose();
    setLoading(true);
    try {
      let payload = {
        stage: stageData?.stage,
        status: stageData?.status,
        sub_status: stageData?.sub_status,
        master_city: stageData?.master_city,
        master_pincode: stageData?.master_pincode,
        remarks: stageData?.remarks,
        nbfc_id: stageData?.nbfc_id,
      };
      // console.log(loan_details);
      if (loan_details) {
        payload = { ...payload, loan_details };
        handleCloseDisbursal();
      }
      let { data } = await updateStageV2(payload, application_id);
      if (data?.status) {
        // setCreatedAppId(data?.application_id);
        // setActiveStep(activeStep + 1);
        setStageData(intialStageData);
        toast.success("Updated");
        clearUpdateState();
        getApplicationDetails(application_id);
        if(state?.path) navigate(state?.path);
        else navigate(-1);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
    }
    setLoading(false);
  };

  const getApplications = async () => {
    let { data } = await fetchAllApplications();
    let list = data?.data?.map((val) => {
      return {
        application_id: val?.application_id,
        name: !val?.customerData?.is_corporate
          ? val?.customerData?.pan_details?.name
          : val?.customerData?.corporate_pan_details?.name,
      };
    });
    setApplications(list);
  };

  React.useEffect(() => {
    if (!app_id) {
      getApplications();
    } else {
      setApplicationId(app_id);
    }

    return () => {
      clearUpdateState();
    };
  }, []);

  const { getApplicationDetails, getNbfc } = useApplication();

  React.useEffect(() => {
    if (application_id !== "") {
      getApplicationDetails(application_id, setLoading);
    }
  }, [application_id]);

  // useEffect(() => {
  //   console.log(stageData);
  // }, [stageData]);

  const handleChange = (prop) => (event) => {
    setUpdateDetails({
      ...updateDetails,
      [prop]: event.target.value,
    });
  };

  useEffect(() => {
    if (updateDetails?.current_stage_data?.stage) {
      setStageData({
        ...intialStageData,
        stage: updateDetails?.current_stage_data?.stage,
        status: stageList[updateDetails?.current_stage_data?.stage]?.STATUS?.[
          updateDetails?.current_stage_data?.status
        ]
          ? updateDetails?.current_stage_data?.status
          : "",

        sub_status: stageList[updateDetails?.current_stage_data?.stage]
          ?.SUB_STATUS?.[updateDetails?.current_stage_data?.status]?.[
          updateDetails?.current_stage_data?.sub_status
        ]
          ? updateDetails?.current_stage_data?.sub_status
          : "",
        master_city: updateDetails?.master_city || "",
        master_pincode:updateDetails?.master_pincode || "",
        // sub_status:
        //   typeof updateDetails?.current_stage_data?.sub_status === "string"
        //     ? updateDetails?.current_stage_data?.sub_status
        //     : "",
        remarks:
          typeof updateDetails?.current_stage_data?.remark === "string"
            ? updateDetails?.current_stage_data?.remark
            : "",
      });
    }
  }, [updateDetails?.application_id]);

  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline />

        <p
          className="go-back-btn"
          onClick={() => {
            if (state?.path) {
              navigate(state?.path);
            } else {
              navigate("/tools");
            }
          }}
        >
          <ArrowBackIcon /> Go back Home
        </p>
        <Container component="main" maxWidth="lg" sx={{ mb: 4 }}>
          <Paper
            variant="outlined"
            sx={{ my: { xs: 3, md: 3 }, p: { xs: 2, md: 3 } }}
          >
            {application_id === "" && (
              <Grid container spacing={3}>
                <Grid item xs={12} sm={12} className="p-5 pb-0">
                  <p className="sub-heading">Edit Application</p>
                  <Autocomplete
                    options={applications}
                    getOptionLabel={(option) =>
                      `${option?.name} - ${option?.application_id}`
                    }
                    id="ApplicationId"
                    clearOnBlur
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Application Id"
                        variant="standard"
                      />
                    )}
                    onChange={(event, value) => {
                      setApplicationId(value?.application_id || "");
                    }}
                  />
                </Grid>
                <p className="text-center w-100">
                  <img
                    className="mt-5"
                    src={uploadIco}
                    width={200}
                    alt="uploading..."
                  />
                </p>
              </Grid>
            )}

            {isLoading && (
              <>
                <p className="text-center">
                  <CircularProgress />
                </p>
                <p className="text-center">Loading</p>
              </>
            )}

            {updateDetails?.application_id !== "" && (
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6} className="p-5 pb-0">
                  <p className="sub-heading">Edit Application</p>
                  <ListItemComp
                    heading={"Application Id:"}
                    text={f(updateDetails?.application_id)}
                  />
                  <ListItemComp
                    heading={"Customer Id:"}
                    text={f(updateDetails?.customer_id)}
                  />
                  <ListItemComp
                    heading={"Customer Name:"}
                    text={f(updateDetails?.customer_name)}
                  />

                  <p className="sub-heading mt-5">Change Status</p>

                  {/* <Grid item xs={12} sm={12} className="mb-3">
                    <Autocomplete
                      options={Object.keys(stageList).map((key) => key)}
                      getOptionLabel={(option) => option?.replaceAll("_", " ")}
                      id="ApplicationId"
                      clearOnBlur
                      value={stageData?.stage}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Stage"
                          variant="standard"
                        />
                      )}
                      onChange={(event, value) => {
                        setStageData({
                          ...stageData,
                          stage: value === null ? "" : value,
                          status: "",setStageData
                          sub_status: "",
                        });
                      }}
                    />
                  </Grid> */}

                  {stageData?.stage !== "" && (
                    <>
                      <Grid item xs={12} sm={12} className="mb-3">
                        <Autocomplete
                          options={Object.keys(
                            stageList[stageData.stage]?.STATUS
                          ).map((key) => key)}
                          getOptionLabel={(option) =>
                            option?.replaceAll("_", " ")
                          }
                          value={stageData?.status}
                          id="ApplicationId"
                          clearOnBlur
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Status"
                              variant="standard"
                            />
                          )}
                          onChange={(event, value) => {
                            setStageData({
                              ...stageData,
                              status: value === null ? "" : value,
                              sub_status: "",
                            });
                          }}
                        />
                      </Grid>
                      {stageList[stageData.stage]?.SUB_STATUS && (
                        <Grid item xs={12} sm={12} className="mb-3">
                          <Autocomplete
                            options={
                              stageList[stageData.stage]?.SUB_STATUS?.[
                                stageData.status
                              ]
                                ? Object.keys(
                                    stageList[stageData.stage]?.SUB_STATUS?.[
                                      stageData.status
                                    ]
                                  ).map((key) => key)
                                : []
                            }
                            getOptionLabel={(option) =>
                              option?.replaceAll("_", " ")
                            }
                            value={stageData?.sub_status}
                            id="ApplicationId"
                            clearOnBlur
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Sub-status"
                                variant="standard"
                              />
                            )}
                            onChange={(event, value) => {
                              console.log(value);
                              setStageData({
                                ...stageData,
                                sub_status: value === null ? "" : value,
                              });
                            }}
                          />
                        </Grid>
                      )}
                      {["MANUALLY_APPROVED", "MANUAL"].includes(
                        stageData?.sub_status
                      ) && updateDetails?.current_stage_data?.stage !== "PRE_DISBURSEMENT" &&
                        stageData?.status === "APPROVED" && (
                          <Grid item xs={12} sm={12} className="mb-3">
                            <AutocompleteCityNames
                              fullWidth={true}
                              label="master city/pincode *"
                              variant="standard"
                              value={stageData?.master_city}
                              onChange={(event, { city, pincode }) => {
                                setStageData({
                                  ...stageData,
                                  master_city: city,
                                  master_pincode: pincode,
                                });
                              }}
                            />
                          </Grid>
                        )}
                      {/* {stageData?.stage === "LOAN_OFFER" &&
                        updateDetails?.current_stage_data?.status ===
                          "UNDER_REVIEW" && (
                          <Autocomplete
                            options={nbfcData}
                            getOptionLabel={(option) => option?.name}
                            // value={stageData?.nbfc_id}
                            id="nbfcId"
                            clearOnBlur
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="NBFC"
                                variant="standard"
                              />
                            )}
                            onChange={(event, value) => {
                              setStageData({
                                ...stageData,
                                nbfc_id: value === null ? "" : value?.nbfc_id,
                              });
                            }}
                          />
                        )} */}

                      <Grid item xs={12} sm={12} className="mt-4">
                        <TextField
                          fullWidth
                          id="outlined-multiline-static"
                          label="Remarks"
                          multiline
                          rows={4}
                          value={stageData?.remarks}
                          onChange={(e) => {
                            setStageData({
                              ...stageData,
                              remarks: e.target.value,
                            });
                          }}
                        />
                      </Grid>
                    </>
                  )}
                </Grid>
                <Grid item xs={12} sm={6} className="p-5">
                  <p className="text-end mb-5">
                    <Button
                      className="w-75"
                      variant="outlined"
                      onClick={() => {
                        clearUpdateState();
                        setStageData(intialStageData);
                        setApplicationId("");
                      }}
                    >
                      Select Another Application
                    </Button>
                  </p>

                  <ListItemComp
                    heading={"Current Stage:"}
                    text={fStatus(updateDetails?.current_stage_data?.stage)}
                  />
                  <ListItemComp
                    heading={"Current Status:"}
                    text={fStatus(updateDetails?.current_stage_data?.status)}
                  />
                  <ListItemComp
                    heading={"Sub-status:"}
                    text={fStatus(
                      updateDetails?.current_stage_data?.sub_status
                    )}
                  />
                  {/* <ListItemComp
                    heading={"Remarks:"}
                    text={f(updateDetails?.current_stage_data?.remark)}
                  /> */}
                </Grid>

                <Grid item xs={12} sm={12}>
                  <div style={{ display: "flex", justifyContent: "end" }}>
                    {isLoading ? (
                      <>
                        <CircularProgress size={20} className="me-2" />
                        Updating
                      </>
                    ) : (
                      <>
                        <Button
                          variant="contained"
                          className="me-2"
                          onClick={handleClickOpen}
                          disabled={
                            stageData?.status === "" ||
                            stageData?.sub_status === "" ||
                            stageData?.stage === "" ||
                            (["MANUALLY_APPROVED", "MANUAL"].includes(
                              stageData?.sub_status
                            ) &&
                              stageData?.status === "APPROVED" &&
                              updateDetails?.current_stage_data?.stage !== "PRE_DISBURSEMENT" &&
                              (!Boolean(stageData?.master_city) ||
                                !Boolean(stageData?.master_pincode)))
                          }
                        >
                          Save Changes
                        </Button>
                        <Button
                          onClick={() => {
                            setStageData(intialStageData);
                            clearUpdateState();
                            setApplicationId("");
                          }}
                        >
                          Cancel
                        </Button>
                      </>
                    )}
                  </div>
                </Grid>
              </Grid>
            )}
          </Paper>
        </Container>
      </ThemeProvider>

      <div>
        <Dialog
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle>{"Confirm Action"}</DialogTitle>
          <DialogContent>
            <p>
              You are about to edit the details of application :{" "}
              <b>{updateDetails?.application_id}</b>. Are you sure to continue ?
            </p>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button onClick={() => handleUpdate()}>Continue</Button>
          </DialogActions>
        </Dialog>
      </div>
      <UpdateDisbursalData
        open={openDisbursal}
        isDisbursal={true}
        handleClose={handleCloseDisbursal}
        onSubmit={validateDisbursalData}
      />
    </>
  );
}

const ListItemComp = ({ icon, heading, text }) => {
  return (
    <ListItem disablePadding>
      <ListItemIcon className="list-key">
        {
          <span>
            {icon && icon}
            {heading}
          </span>
        }
      </ListItemIcon>
      <ListItemText
        primaryTypographyProps={{ fontSize: "15px" }}
        className="list-value"
        primary={text}
      />
    </ListItem>
  );
};
